var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Honduras(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1976d2",
    d: "M24,4C15.421,4,8.125,9.412,5.284,17h37.431C39.875,9.412,32.579,4,24,4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M44,24c0-2.467-0.468-4.818-1.284-7H5.284C4.468,19.182,4,21.533,4,24s0.468,4.818,1.284,7h37.431 C43.532,28.818,44,26.467,44,24z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1976d2",
    d: "M42.716,31H5.284C8.125,38.588,15.421,44,24,44S39.875,38.588,42.716,31z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#1976d2",
    d: "M24.473,24L24,22.547L23.527,24H22l1.234,0.898l-0.469,1.453L24,25.453l1.234,0.898l-0.469-1.453 L26,24H24.473z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#1976d2",
    d: "M30.766,23.359L32,22.461l1.234,0.898l-0.469-1.453L34,21.008h-1.527L32,19.555l-0.473,1.453H30 l1.234,0.898L30.766,23.359z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#1976d2",
    d: "M32.473,26.008L32,24.555l-0.473,1.453H30l1.234,0.895l-0.469,1.457L32,27.461l1.234,0.898 l-0.469-1.457L34,26.008H32.473z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#1976d2",
    d: "M16,19.555l-0.473,1.453H14l1.234,0.895l-0.469,1.457L16,22.461l1.234,0.898l-0.469-1.457L18,21.008 h-1.527L16,19.555z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#1976d2",
    d: "M16.473,26.008L16,24.555l-0.473,1.453H14l1.234,0.895l-0.469,1.457L16,27.461l1.234,0.898 l-0.469-1.457L18,26.008H16.473z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Honduras);
export default __webpack_public_path__ + "static/media/icons8-honduras.bbd3528fad0c395606f0b7d58be953af.svg";
export { ForwardRef as ReactComponent };